import React from 'react';
import { withRouter } from 'react-router-dom';
import AuthUserContext from './context';
import { withFirebase } from '../Firebase';
import * as ROUTES from '../../constants/routes';

type WithAuthorizationProps = {
    history: any,
    firebase: any
}

/** Build a sign-in URL that preserves the current location so SignIn can
 *  redirect back after authentication. Skips the next=... param when the user
 *  is already on the sign-in page (avoids next=/ loops). */
function signInUrlWithNext(): string {
    const here = window.location.pathname + window.location.search + window.location.hash;
    if (!here || here === '/' || here === ROUTES.SIGN_IN) return ROUTES.SIGN_IN;
    return `${ROUTES.SIGN_IN}?next=${encodeURIComponent(here)}`;
}

const withAuthorization = (condition: any) => (Component: any) => {
    class WithAuthorization extends React.Component<WithAuthorizationProps> {
        listener: any;
        componentDidMount() {
            this.listener = this.props.firebase.onAuthUserListener(
                (authUser: any) => {
                    if (!condition(authUser)) {
                        this.props.history.push(signInUrlWithNext());
                    }
                },
                () => this.props.history.push(signInUrlWithNext()),
            );
        }
        componentWillUnmount() {
            this.listener();
        }
        render() {
            return (
                <AuthUserContext.Consumer>
                    {authUser =>
                        condition(authUser) ? <Component {...this.props} /> : null
                    }
                </AuthUserContext.Consumer>
            );
        }
    }
    return withRouter(withFirebase(WithAuthorization))

};
export default withAuthorization;